import { FocusEventHandler } from "react";

/**
 * Provides blur handing logic for a parent; firing callback only
 * when focus has left both children and parent
 */
const handleBlurParent = (
  onBlur: (event: React.FocusEvent<HTMLDivElement>) => void,
): FocusEventHandler<HTMLDivElement> => (event) => {
  const { currentTarget } = event;
  setTimeout(() => {
    if (currentTarget.contains(document.activeElement)) return;
    onBlur(event);
  }, 0);
};

export default handleBlurParent;
